(ns iris.posts.views.posts-logs-switch
  (:require
   [re-frame.core :as re-frame]
   [clojure.string :as string]
   [iris.routes :as routes]
   [iris.subs :as subs]))

(defn normal-primary-click? [e]
  (and (not (.-defaultPrevented e))
       (= 0 (or (.-button e) 0))
       (not (or (.-altKey e)
                (.-ctrlKey e)
                (.-metaKey e)
                (.-shiftKey e)))))

(defn route-to-posts-href! [e posts-href]
  (when (normal-primary-click? e)
    (.preventDefault e)
    (.stopPropagation e)
    (routes/route-to! posts-href)))

(defn posts-logs-switch []
  (let [{:keys [posts-href logs-href mirrored?]} @(re-frame/subscribe [::subs/mirror-hrefs])
        handler  @(re-frame/subscribe [::subs/handler])
        on-logs? (string/starts-with? (name (or handler :_)) "logs")]
    (when mirrored?
      [:div {:style {:text-align "center" :margin "15px 0"}}
       [:div.btn-group.btn-group-sm {:role "group"}
        [:a.btn {:href  posts-href
                 :on-click #(route-to-posts-href! % posts-href)
                 :class (if-not on-logs? "btn-primary" "btn-default")}
         [:i.glyphicon.glyphicon-list]
         " Posts"]
        [:a.btn {:href  logs-href
                 :class (if on-logs? "btn-primary" "btn-default")}
         [:i.glyphicon.glyphicon-list-alt]
         " Logs"]]])))
